import { render } from "./component-egrul-kod.vue?vue&type=template&id=24eefd94"
import script from "./component-egrul-kod.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-kod.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-kod.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24eefd94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24eefd94', __exports__)) {
    api.reload('24eefd94', __exports__)
  }
  
  module.hot.accept("./component-egrul-kod.vue?vue&type=template&id=24eefd94", () => {
    api.rerender('24eefd94', render)
  })

}


export default __exports__